// extracted by mini-css-extract-plugin
export default {"info__header":"index_info__header__fsTdz","header__title":"index_header__title__NjbLP","header__desc":"index_header__desc__Htmkh"};